var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMoonFilledBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4792 1.5835C12.92 1.5835 14.2738 1.97933 15.4375 2.65225C13.0704 4.02183 11.4792 6.571 11.4792 9.50016C11.4792 12.4293 13.0704 14.9785 15.4375 16.3481C14.2738 17.021 12.92 17.4168 11.4792 17.4168C7.10917 17.4168 3.5625 13.8702 3.5625 9.50016C3.5625 5.13016 7.10917 1.5835 11.4792 1.5835Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoonFilledBlack);
export default __webpack_public_path__ + "static/media/icon-moon-filled-black.e8c7ae6a5a96d8917d41d47afac2a971.svg";
export { ForwardRef as ReactComponent };